import * as React from 'react';
import styled from 'styled-components';
import { IModelEntity } from '../../../data/types';
import { Avatar } from '../Avatar';
import { Icon } from '../Icon';

interface IProps {
  entity: Partial<IModelEntity>;
  secondaryText?: string;
  labelOverride?: string;
  onClick?: () => void;
  inverse?: boolean;
  pdf?: boolean;
  large?: boolean;
  error?: string;
  style?: React.CSSProperties;
}

const ListAvatarContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
`;
const SecondaryTextContainer = styled.div`
  color: var(--color-secondary-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  min-width: 0;
  flex: 1;
`;

const NameContainer = styled.span<{ inverse?: boolean; large?: boolean }>`
  color: ${(props: { inverse?: boolean }): string =>
    props?.inverse ? 'var(--color-dark-text)' : 'var(--color-text)'};
  font-size: ${(props: { large?: boolean }): string =>
    props?.large
      ? '1.5rem'
      : 'calc(12px + (2) * ((100vw - 300px) / (1600 - 300)))'};
  line-height: ${(props: { large?: boolean }): string =>
    props?.large
      ? '1.5rem'
      : 'calc(1.3em + (1.5 - 1.2) * ((100vw - 300px) / (1600 - 300)))'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

const ListAvatar = (props: IProps): React.ReactElement => {
  return (
    <ListAvatarContainer onClick={props.onClick} style={props.style}>
      {props.error ? (
        <Icon
          name='error'
          style={{ color: 'red' }}
          size='list-avatar'
          title={props.error}
        />
      ) : (
        <Avatar
          alt={props.entity.name}
          size={props.large ? 'medium' : 'list-avatar'}
          src={props.entity.image}
          imageToken={props.entity.imageToken}
          inverse={props.inverse}
          pdf={props.pdf}
        />
      )}
      <TextContainer>
        <NameContainer
          inverse={props.inverse}
          large={props.large}
          title={props.labelOverride ?? props.entity.name}
        >
          {props.labelOverride ?? props.entity.name}
        </NameContainer>
        <SecondaryTextContainer title={props.secondaryText}>
          {props.secondaryText}
        </SecondaryTextContainer>
      </TextContainer>
    </ListAvatarContainer>
  );
};

export { ListAvatar };
